import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import PurchaseQuoteForm from '../../components/Purchase/purchaseQuoteForm';
import { fetchVendors, fetchVendorDetail, resetCurrentVendor } from '../../actions/vendors_actions';
import { fetchProductsByVendor, fetchProductInfo, fetchSimplifiedProducts } from '../../actions/products_actions';
import { fetchPaymentTerms } from '../../actions/paymentTerms_actions';
import { fetchPurchaseQuoteDetail, editPurchaseQuote, createPurchaseQuote, purchaseQuotePlace } from '../../actions/purchaseQuotes_actions';
import { fetchWarehouses } from '../../actions/warehouses_actions';
import { createPurchaseOrder, setPriceValues } from '../../actions/purchaseOrders_actions';
import { convertTemplateToQuote } from '../../actions/purchaseTemplates_actions';


let purchaseQuoteForm = reduxForm({
    form: 'purchaseQuoteForm',
})(PurchaseQuoteForm);

const selector = formValueSelector('purchaseQuoteForm')

function mapStateToProps(state) {
    const productInformation = selector(state, 'ProductInformation');

    const productsValue = selector(state, 'Purchase_Order_Line');
    const vendorsValue = selector(state, 'Vendor_id');
    const vendorContactValue = selector(state, 'VendorContact');
    const priceTypeValue = selector(state, 'ConvertItemPrice');
    const miscCostValue = selector(state, 'MiscCost');
    const handlingCostValue= selector(state, 'HandlingCost');
    const shippingCostValue = selector(state, 'ShippingCost');
    const discountValue = selector(state, 'Discount');
    const taxValue = selector(state, 'TaxRate');
    const allProducts = selector(state, 'AllProducts');
    const allProdQuantity = selector(state, 'AllProd_Quantity');
    const allProdFOBUnitPrice = selector(state, 'AllProd_FOBUnitPrice');
    const allProdEstSalePrice = selector(state, 'AllProd_EstSalePrice');
    // Dumb way to get the formProps
    const formProps = selector(state,
        'OrderDate',
        'ETADate',
        'ReceivedDate',
        'FinalNetWeight',
        'FinalShippingWeight',
        'TotalPrice',
        'NoteToVendor',
        'ReleaseInformation',
        'CarryType',
        'Discount',
        'ShippingCost',
        'HandlingCost',
        'MiscCost',
        'MiscNote',
        'TaxRate',
        'PaymentStatus',
        'PurchaseStatus',
        'FinalPrice',
        'ConvertItemPrice',
        'Vendor_id',
        'Pickup_VendorAddress_id',
        'Pickup_VendorContact_id',
        'Deliver_Warehouse_id',
        'DispatchMethod_id',
        'DispatchOutSourceContact_id',
        'Purchaser_User_id',
        'Modifier_User_id',
        'PaymentTerm_id'
    )
    return {
        productInformation: productInformation,
        productsValue,
        vendorsValue,
        vendorContactValue,
        priceTypeValue,
        miscCostValue,
        shippingCostValue,
        handlingCostValue,
        discountValue,
        taxValue,
        formProps,
        allProducts,
        allProdQuantity,
        allProdFOBUnitPrice,
        allProdEstSalePrice,

        currentPurchaseTemplateDetail: state.purchaseTemplates.currentPurchaseTemplateDetail,
        currentPurchaseTemplate: state.purchaseTemplates.currentPurchaseTemplate,
        currentPurchaseQuoteDetail: state.purchaseQuotes.currentPurchaseQuoteDetail,
        currentPurchaseQuote: state.purchaseQuotes.currentPurchaseQuote,
        detailIsLoading: state.purchaseQuotes.detailIsLoading || state.purchaseTemplates.detailIsLoading,
        detailError: state.purchaseQuotes.detailError || state.purchaseTemplates.detailError,
        initialValues: state.purchaseQuotes.currentPurchaseQuoteDetail || state.purchaseTemplates.currentPurchaseTemplateDetail,

        isEditing: state.purchaseQuotes.purchaseQuoteIsEditing,
        editError: state.purchaseQuotes.purchaseQuoteEditError,
        isCreating: state.purchaseQuotes.purchaseQuoteIsCreating || state.purchaseOrders.purchaseOrderIsCreating,
        createError: state.purchaseQuotes.purchaseQuoteCreateError || state.purchaseOrders.purchaseOrderCreateError,
        isPlacing: state.purchaseQuotes.purchaseQuoteIsPlacing,
        placeError: state.purchaseQuotes.purchaseQuotePlaceError,

        products: state.products.allByVendor,
        productIsLoading: state.products.isLoading,
        productError: state.products.error,
        productInfo: state.products.productInfo,
        productInfoIsLoading: state.products.productInfoIsLoading,
        productInfoError: state.products.productInfoError,
        vendors: state.vendors.all,
        vendorIsLoading: state.vendors.isLoading,
        vendorError: state.vendors.error,
        currentVendorDetail: state.vendors.currentVendorDetail,
        vendorDetailIsLoading: state.vendors.detailIsLoading,
        vendorDetailError: state.vendors.detailError,
        paymentTerms: state.paymentTerms.all,
        paymentTermsIsLoading: state.paymentTerms.isLoading,
        paymentTermsError: state.paymentTerms.error,
        warehouses: state.warehouses.all,
        warehouseIsLoading: state.warehouses.isLoading,
        warehouseError: state.warehouses.error,
        userPermissions: state.auth.userPermissions,

        simplifiedProducts: state.products.simplifiedProducts,
        simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
        simplifiedProductsError: state.products.simplifiedProductsError,
    }
}

export default connect(mapStateToProps, {
  purchaseQuotePlace, fetchVendors, fetchProductsByVendor, fetchProductInfo,
  fetchPaymentTerms, fetchVendorDetail, resetCurrentVendor, fetchPurchaseQuoteDetail,
  convertTemplateToQuote, editPurchaseQuote, createPurchaseQuote, createPurchaseOrder,
  fetchWarehouses, fetchSimplifiedProducts, setPriceValues })(purchaseQuoteForm)



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchaseQuoteForm.jsx